"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONNECTOR_TYPE = exports.STANDARD_INJECT_WALLET = exports.OTHER_INJECT_WALLET = exports.OKX_TG_WALLET = exports.OKX_APP_WALLET = exports.OKX_INJECT_WALLET = void 0;
exports.getTagByappName = getTagByappName;
const protocol_1 = require("../protocol");
const wallet_info_1 = require("../protocol/connect/wallet-info");
exports.OKX_INJECT_WALLET = "okx_inject_wallet";
exports.OKX_APP_WALLET = "okx_app_wallet";
exports.OKX_TG_WALLET = "okx_tg_wallet";
exports.OTHER_INJECT_WALLET = "other_inject_wallet";
exports.STANDARD_INJECT_WALLET = "standard_inject_wallet";
exports.CONNECTOR_TYPE = {
    NOT_INSTALLED: -1,
    WS: {
        OKX_APP_WALLET: 100,
        OKX_TG_WALLET: 110
    },
    INJECT: {
        OKX_INJECT_WALLET: 200,
        STANDARD_INJECT_WALLET: 210
    },
    KEYLESS: {
        APPLE_WALLET: 300,
        GOOGLE_WALLET: 310
    }
};
function getTagByappName(appName) {
    var tag = '';
    if (appName) {
        switch (appName) {
            case protocol_1.OKXWalletName:
                tag = exports.OKX_APP_WALLET;
                break;
            case wallet_info_1.OKXMiniWalletName:
                tag = exports.OKX_TG_WALLET;
                break;
            case wallet_info_1.OKXInjectWalletName:
                tag = exports.OKX_INJECT_WALLET;
        }
    }
    return tag || appName || '';
}
